export default "__VITE_ASSET__BO7syaSj__"